<template>
  <div id="app">
    <router-view v-if="isForbiddenVisit" />
    <h3 v-else style="padding: 0 20px">{{ $t('请下载桌面客户端程序进行访问!') }}</h3>
    <el-dialog
      class="updater-dialog"
      :width="$pxToRem(508)"
      :visible.sync="isAvailableUpdate"
      :title="$t(`更新提示`)"
      :append-to-body="true"
      :show-close="false"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
    >
      <div class="text-center font-22">
        <el-progress v-if="downloadingApp" type="circle" :percentage="percent" />
        <div class="flex flex-col" v-else>
          <div>{{ versionTips }}</div>
          <div class="mt-10 font-18">{{ $t('当前版本v') }}{{ appVersion }}</div>
        </div>
      </div>
      <span slot="footer" class="flex items-center justify-center update-dialog-buttons">
        <el-button @click="handleCancel" :disabled="downloadingApp">{{ $t('以后再说') }}</el-button>
        <el-button @click="downloadApp" :disabled="downloadingApp" type="primary">{{ $t('现在更新') }}</el-button>
      </span>
    </el-dialog>
    <!-- <AIBotAssistant v-show="isCashierPage" /> -->
  </div>
</template>
<script>
  import { throttle } from 'lodash-es'
  import { ipc, isEE } from '@/utils/ipcRenderer'
  import ipcApiRoute from '@/constants/ipcApiRoute'
  import { AppInfoStorage } from '@/utils/storage'
  import i18n from '@/locale'
  //import AIBotAssistant from '@/components/ai-chat/index'
  export default {
    // components: {
    //   AIBotAssistant,
    // },
    data() {
      return {
        isEE,
        isAvailableUpdate: false,
        downloadingApp: false,
        versionTips: '',
        appVersion: null,
        percent: 0,
      }
    },
    computed: {
      isForbiddenVisit() {
        if (localStorage.getItem('POS_DEBUG')) return true
        if (location.host === 'pos.mg.cn') return this.isEE
        return true
      },
      // isCashierPage() {
      //   return ['/', '/cashier'].includes(this.$route.path)
      // },
    },
    created() {
      // 以1440为标准宽度，16:9屏幕比例进行整体缩放
      const fontRatio = 1440 / 16
      function onResize() {
        const width = window.innerWidth
        const rootFontSize = width / fontRatio
        document.documentElement.style.setProperty('font-size', `${rootFontSize}px`)
      }
      const throttleOnResize = throttle(onResize, 300)
      window.addEventListener('resize', throttleOnResize)
      window.addEventListener('offline', this.onOffline)

      this.$off('hooks:beforeDestroy', () => {
        window.removeEventListener('resize', throttleOnResize)
        window.removeEventListener('offline', this.onOffline)
      })

      onResize()

      ipc.on(ipcApiRoute.messageBox, (event, result) => {
        if (result.type == 'message') {
          this.$mgMessage(result.message, 'warning')
        }
      })
      this.$once('hook:beforeDestroy', () => {
        ipc.removeAllListeners(ipcApiRoute.messageBox)
      })
      this.getAppInfo()
    },
    mounted() {
      ipc.removeAllListeners(ipcApiRoute.appUpdater)
      ipc.on(ipcApiRoute.appUpdater, (event, result) => {
        result = JSON.parse(result)
        const { version, status, percent } = result
        if (status == 1) {
          this.isAvailableUpdate = true
          this.versionTips = i18n.t('检测到有新版本 v{version}，是否现在更新?', { version: version })
        } else if (status == 2) {
          this.versionTips = i18n.t('已经是最新版本')
        } else if (status == 3) {
          this.downloadingApp = true
          this.percent = percent
        } else if (status == 4) {
          this.downloadingApp = false
          this.isAvailableUpdate = false
          this.$nextTick(() => {
            this.$mgAlert(i18n.t('下载完成，是否立即重启完成更新?'), i18n.t('更新提示')).then(() => {
              ipc.invoke(ipcApiRoute.relaunchApp)
              // console.log('TIPS APP 下载完成 并重启')
              // window.location.reload()
            })
          })
        }
      })
      this.checkForUpdater()
    },
    methods: {
      getAppInfo() {
        ipc.invoke(ipcApiRoute.getAppInfo).then((result) => {
          const { currentVersion } = result
          this.appVersion = currentVersion
          AppInfoStorage.set(result)
        })
      },
      handleCancel() {
        this.isAvailableUpdate = false
      },
      checkForUpdater() {
        ipc.invoke(ipcApiRoute.checkForUpdater)
      },
      downloadApp() {
        ipc.invoke(ipcApiRoute.downloadApp)
        console.log('TIPS APP downloadApp')
      },
      onOffline() {
        if (this.isEE) {
          ipc.send(ipcApiRoute.offline)
          return
        }
        alert(i18n.t('检测到网络异常，请检查网络后刷新重试!'))
      },
    },
  }
</script>
<style lang="less">

  
  //让appedntobody的dialog也有header
  // .mg-dialog-custom .el-dialog__header {
  //   display: flex !important;
  //   align-items: center;
  //   padding: 20px 24px;
  //   font-size: 22px;
  //   font-weight: 600;
  //   border: none !important;
  // }

  // .mg-dialog-custom .el-dialog__body {
  //   padding-left: 12px !important;; 
  //   padding-right: 12px !important;;
  // }
  #app {
    height: 100vh;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

.no-frame-dialog{
  .el-dialog__header{
    display: none;
  }
  .el-dialog__body {
    padding: 0px;
  }
}
  .price-diff {
    color: red;
  }
  input::placeholder {
    font-size: 16px;
    font-weight: normal;
  }
  .vxe-table--render-default .vxe-body--column.col--right .el-form-item__content input:disabled {
    text-align: right;
  }
  .updater-dialog {
    .el-dialog__header {
      padding: 20px 24px;
      font-weight: 600;
      .el-dialog__title {
        font-size: 22px;
      }
    }
  }
  .update-dialog-buttons {
    button {
      width: 190px;
      height: 56px;
      &:nth-child(2) {
        margin-left: 20px;
      }
    }
  }
</style>
